module.exports = __webpack_public_path__ + "static/img/IMG_20160310_223302.6314a535.jpg";